<template>
  <fieldset>

    <legend>
      <span class="pull-left">{{ $t('form.working_conditions.legend') }}</span>
      <!-- <a class="fa fa-question-circle" @click="displayModal($event, 0)" /> -->
      <a class="pull-right" ref="collapseLink" data-toggle="collapse" href="#collapse_working_conditions" role="button"
        aria-expanded="true" aria-controls="collapse_working_conditions">
        <span class="fa fa-angle-up"></span>
        <span class="fa fa-angle-down"></span>
      </a>
    </legend>

    <modal v-show="modals[0]" @close="$set(modals, 0, false)">
      <h2 slot="modal-header">{{ $t('form.working_conditions.legend') }}</h2>
      <div slot="modal-body">

      </div>
    </modal>

    <div class="collapse show" id="collapse_working_conditions" ref="collapseElement">

      <div>
        <label for="working_condtion_shift">
          <input type="checkbox" id="working_condtion_shift" v-model="workingConditions.shift">
          {{ $t('form.working_conditions.shift.label') }}
        </label>
      </div>

      <div>
        <label for="working_condtion_inconvenient">
          <input type="checkbox" id="working_condtion_inconvenient" v-model="workingConditions.inconvenient">
          {{ $t('form.working_conditions.inconvenient.label') }}
        </label>
      </div>

    </div>
  </fieldset>
</template>

<script>
export default {
  data() {
    return {
      workingConditions: {
        shift: false,
        inconvenient: false,
      },
    };
  },
  watch: {
    workingConditions: {
      handler() {
        this.$store.commit('updateWorkingConditions', this.workingConditions);
      },
      deep: true,
    },
  },
};
</script>